/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoanReportDto { 
    id?: number;
    message?: string | null;
    creationTime?: string | null;
    userId?: number;
    amount?: number;
    userName?: string | null;
    loanId?: number;
    status?: string | null;
    transactionModeType?: string | null;
    paymentProviderName?: string | null;
    initiatedBy?: string | null;
}

